import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IFdeLicense } from '../../../../types/licensedDrives';

export interface IGenerateFdeLicense {
    maintenanceExpiration: string,
    selectedCount: number,
    selectedLicenses:  IFdeLicense[]
}

@Component({
    selector: 'app-generate-fde-license-dialog',
    templateUrl: './generate-fde-license-dialog.component.html',
    styleUrl: './generate-fde-license-dialog.component.scss',
    standalone: false
})
export class GenerateFdeLicenseDialogComponent {
    @Output() workstationIdSubmitted: EventEmitter<void> = new EventEmitter<void>();
    formGroup: FormGroup;
    selectedCount: number;

    constructor(@Inject(MAT_DIALOG_DATA) public data: IGenerateFdeLicense,
                private readonly formBuilder: UntypedFormBuilder,
                private readonly dialogRef: MatDialogRef<GenerateFdeLicenseDialogComponent>) {
        this.selectedCount = data.selectedCount
        this.formGroup = this.formBuilder.group({
          maintenanceExpiration: [data.maintenanceExpiration, Validators.required]
        });
    }

  onSaveClick() {
    this.dialogRef.close(this.formGroup.value.maintenanceExpiration);
  }

  onCancelClick() {
    this.dialogRef.close();
  }
}
